<template>
    <div >
        <div class="leaguesList">
            <div  v-for="(tours) in tournaments" :key="tours[0].category.id" >
            <div class="someLeague">
            <a class="someLeague" data-toggle="collapse" :href="'#collapseExample14' + tours[0].category.id" role="button" aria-expanded="false" aria-controls="collapseExample">
              <p class="CountryName MobileHide" style="color: white;"><img :src="src + tours[0].category.id" style="width: 28px; margin-right: 10px;" v-if="tours[0].category.icon != null"><img src="@/assets/int.png" style="width: 28px; margin-right: 10px;" v-else><span v-if="ssize > 768 && ssize <= 992" >{{tours[0].category.name.slice(0,7)}}</span> <span v-else-if="ssize <= 768" ></span> <span v-else> {{tours[0].category.name.slice(0,15)}} </span> </p>
              <p class="CountryName MobileShow" style="color: white;"><img :src="src + tours[0].category.id" style="width: 28px; margin-right: 10px;" v-if="tours[0].category.icon != null"><img src="@/assets/int.png" style="width: 28px; margin-right: 10px;" v-else> {{tours[0].category.name}} </p>
            </a>
          </div>
            <div class="collapse onMobile" :id="'collapseExample14' + tours[0].category.id" v-for="(league, i) in tours" :key="league.id">
              <ul style="list-style-type:none;">
                  <li v-bind:class="{margin: i >= 1}"> 
                  <div class="row" v-if="!cookiesObject.token"> 
                  <span data-toggle="modal" data-target="#exampleModal" class="col MobileHide" style="cursor: pointer; border-bottom: 1px solid rgba(191, 191, 191, 0.1);">{{league.name}}</span>
                  <b-btn data-toggle="modal" data-target="#exampleModal" class="MobileHide" style="margin-right: 20px; background: none; border: none; vertical-align: middle;" size="sm"> <img src="@/assets/favorite.png" style="width: 15px; vertical-align: middle;" alt=""> </b-btn> 
                  <span  v-b-modal.modal-multi-1 class="col MobileShow" style="cursor: pointer;">{{league.name}}</span>
                  <b-btn v-b-modal.modal-multi-1 class="MobileShow" style="margin-right: 20px; background: none; border: none;" size="sm"> <img src="@/assets/favorite.png" style="width: 15px; "> </b-btn> 
                  </div>
                  <div  v-else> 
                  <div class="row">
                  <router-link class="col" style="border-bottom: 1px solid rgba(191, 191, 191, 0.1);" :to="{ name: 'LeaguePageNav', params: { leagueId: league.id }}" id="router-link"> <span> {{league.name}} </span> </router-link> 
                  <b-btn v-if="favsT.some(fav => fav.id === league.id)" v-on:click="removeFavorite({value: league.id , type: tournament})" style="margin-right: 20px; background: none; border: none;" size="sm"> <img src="@/assets/favorite1.png" style="width: 15px; " alt=""> </b-btn> <b-btn v-else v-on:click="addToFavorites({value: league.id , type: tournament})" style="margin-right: 20px; background: none; border: none;" size="sm"> <img src="@/assets/favorite.png" style="width: 15px; " alt=""> </b-btn> 
                  </div>
                  </div>
                  </li>
               </ul> 
              </div>
              </div>
              
    </div>
    </div>
  
</template>

<script>
import {mapGetters, mapActions} from 'vuex';



export default {
  name: 'Leagues',
  data(){
      return{
          leagueList: [],
          cookiesObject: '',
          tournament: 'tournament',
          tournaments: [],
          src: 'https://sportapi.zuniac.com/category/logo/',
          ssize: '',
      }
  },
  methods: {
      ...mapActions(["removeFavorite", "addToFavorites"]),
       nowSize(){
        this.ssize = window.innerWidth;
      }
  },

   async mounted(){
     var cookiesObject = document.cookie.split(';').map(cookie => cookie.split('=')).reduce((accumulator, [key, value]) => ({...accumulator, [key.trim()]: decodeURIComponent(value)}),{});
    this.cookiesObject = cookiesObject;


      if (cookiesObject.token) {
      const res = await fetch(this.httpReq  + '/sport/leagues?langId=' + this.cookiesObject.langId + '&portalId='+ this.cookiesObject.portalId +'&sportId=1&token=' + cookiesObject.token);
      const data = await res.json();
      const leagueList = data.leagues;
      this.leagueList = leagueList;

      if (data.code == 200) {
       //everything is okay
    }
    else if (data.code == 401) {
      alert('Logged from another browser, try to re sign!');
         document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
    } else if(data.code == 404){
        alert('Token is not valid and portal id not provided')
        document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
    }
    else if(data.code == 500){
        alert('Server side error')
        document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
    } else {
        alert('service error')
        document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
    }

      } else {
      const res = await fetch(this.httpReq  + '/sport/leagues?langId=' + this.cookiesObject.langId + '&portalId='+ this.cookiesObject.portalId +'&sportId=1');
      const data = await res.json();
      const leagueList = data.leagues;
      this.leagueList = leagueList;
      }
  
     const tournaments = {};
    this.leagueList.forEach((e) => {
        const tourid = e.category.name;

        if(typeof tournaments[tourid] === 'undefined') {
            tournaments[tourid] = [];
        }

        tournaments[tourid].push(e);
    });
    
    // this.games = games;
    this.tournaments = tournaments;

    window.addEventListener('resize', this.nowSize);
    this.nowSize();
  },

  destroyed(){
      window.removeEventListener('resize', this.nowSize);
    
    },
   
  computed: {
      ...mapGetters(["favsT",'httpReq']),
  },
}
</script>

<style scoped>
.margin{
  margin-top: -15px;
}

#router-link{
  color: white;
  text-decoration: none;
}
    .leaguesList{
    background: #333333;
    border-radius: 5px;
    /* width: 220px; */
}

.leaguesListUl{
    color: white;
}

.someLeague{
    /* width: 210px !important; */
    height: 50px !important;
    color: white;
    text-align: center;
    padding-top: 3%;
    
}

.someLeague:hover{
    text-decoration: none;
    color:white;
}

.collapse{
    color: white;
}

.CountryName{
    background: #4d4d4d;
    /* width: 210px; */
    height: 40px;
    border-radius: 5px;
    margin-left: 5px;
    margin-right: 5px;
    padding-top: 3%;
    text-align: start;
    padding-left: 15px ;
    font-size: 14px;
}
li{
  font-size: 14px;
  margin-left: -20px;
}
@media only screen and (max-width: 770px) {
  .MobileHide {
    display: none;
  }
   .leaguesList{
    background: #333333;
    border-radius: 0;
    width: 100%;
}
  .someLeague{
    width: 95% !important;
    height: 50px !important;
    color: white;
    text-align: center;
    padding-top: 3%;   
}
.CountryName{
    background: #4d4d4d;
    width: 100%;
    height: 40px;
    border-radius: 5px;
    margin-left: 5px;
    padding-top: 2%;
    text-align: start;
    margin-top: -10px;    
}
.onMobile{
  width: 95%;
}
   
}

@media only screen and (min-width: 770px) {
  .MobileShow {
    display: none;
  }
}

</style>
